/** Backend API base (no trailing slash). Override with REACT_APP_API_URL at build time. */
export const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(
  /\/$/,
  ''
);
